var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "report-center-wrap" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "flex-row-between-center title-top" }, [
          _c("div", { staticClass: "title-left" }, [
            _vm._v("\n        订单报备\n      ")
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "apply-btn", on: { click: _vm.goCreate } }, [
            _vm._v("去报备")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "top-info" }, [
          _vm._v(
            "\n      针对部分订单受影响的情况进行报备，报备审核通过后对指定的订单生效。\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "gray-bg" }),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "searchForm",
          staticClass: "demo-form-inline",
          staticStyle: { "margin-bottom": "10px" },
          attrs: {
            "label-position": "right",
            inline: true,
            model: _vm.searchForm
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "申请ID" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.searchForm.ids,
                  callback: function($$v) {
                    _vm.$set(_vm.searchForm, "ids", $$v)
                  },
                  expression: "searchForm.ids"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "状态" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", multiple: "", placeholder: "请选择" },
                  model: {
                    value: _vm.searchForm.status,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "status", $$v)
                    },
                    expression: "searchForm.status"
                  }
                },
                _vm._l(_vm.statusList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { value: item.value, label: item.label }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "延迟发货原因", "label-width": "120px" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择" },
                  model: {
                    value: _vm.searchForm.delay_reason,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "delay_reason", $$v)
                    },
                    expression: "searchForm.delay_reason"
                  }
                },
                _vm._l(_vm.reasonList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { value: item.value, label: item.label }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "发起时间" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "300px" },
                attrs: {
                  type: "daterange",
                  "range-separator": "~",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期"
                },
                model: {
                  value: _vm.searchForm.date,
                  callback: function($$v) {
                    _vm.$set(_vm.searchForm, "date", $$v)
                  },
                  expression: "searchForm.date"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v("\n        查询\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: {
                    background: "#fff",
                    color: "#666",
                    "border-color": "#ccc"
                  },
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.resetForm }
                },
                [_vm._v("重置\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.exportLoading
                  },
                  on: {
                    click: function($event) {
                      return _vm.onExport()
                    }
                  }
                },
                [_vm._v("\n        导出\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "padding-top": "8px" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticStyle: { width: "100%", "text-align": "center" },
              attrs: {
                data: _vm.tableData,
                size: "mini",
                "row-key": function(row) {
                  return row.id
                }
              },
              on: {
                select: _vm.handleSelect,
                "select-all": _vm.handleSelectAll
              }
            },
            [
              _vm._v("\n      >\n      "),
              _c("el-table-column", { attrs: { type: "selection" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "id", label: "申请ID", width: "80" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "report_type_str", label: "报备类型" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "report_reason_str",
                  label: "延迟发货原因",
                  width: "180"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "report_detailed_reason",
                  label: "备注",
                  "show-overflow-tooltip": true
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status_str", label: "报备状态" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created_at", label: "发起时间", width: "180" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "review_time", label: "审核时间", width: "180" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "review_comment",
                  label: "审核备注",
                  "show-overflow-tooltip": true
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "opt-btn",
                            on: {
                              click: function($event) {
                                return _vm.goDetail(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("查看")]
                        ),
                        _vm._v(" "),
                        scope.row.status == 2
                          ? _c(
                              "span",
                              {
                                staticClass: "opt-btn",
                                staticStyle: { margin: "0 8px" },
                                on: {
                                  click: function($event) {
                                    return _vm.reject(scope.row.id)
                                  }
                                }
                              },
                              [_vm._v("\n            撤消\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 1 || scope.row.status == 2
                          ? _c(
                              "span",
                              {
                                staticClass: "opt-btn",
                                on: {
                                  click: function($event) {
                                    return _vm.goEdit(scope.row)
                                  }
                                }
                              },
                              [_vm._v("修改")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        staticStyle: { "text-align": "center" },
        attrs: {
          "current-page": _vm.queryInfo.page,
          "page-sizes": [10, 20, 50, 100, 200, 500],
          "page-size": _vm.queryInfo.page_size,
          layout: "total,sizes, prev, pager, next,jumper",
          total: _vm.queryInfo.total
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
          "update:currentPage": function($event) {
            return _vm.$set(_vm.queryInfo, "page", $event)
          },
          "update:current-page": function($event) {
            return _vm.$set(_vm.queryInfo, "page", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "el-icon-warning c-red" }),
      _vm._v(
        "\n        请于每月最后一个工作日前发起报备，发起报备后平台预计\n        "
      ),
      _c("span", { staticClass: "c-red" }, [_vm._v("1个工作日")]),
      _vm._v("反馈结果，请您耐心等待\n      ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-075e9dfd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-075e9dfd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderReport/reportCenter/index.vue
// module id = null
// module chunks = 